import axiosStock, { AxiosError } from 'axios'

const instance = axiosStock.create({ baseURL: process.env['NEXT_PUBLIC_URL'] || '' })
export const axios = instance

axios.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(handleAxiosError(error) || 'Axios Error - Something went wrong')
  }
)

// axios.interceptors.response.use(
//   response => response,
//   error => {
//     // console.warn('full axios error here: ', error)
//     return Promise.reject((error.response?.data && error.response.data) || 'Axios Error - Something went wrong')
//   }
// )

export default axios

export function handleAxiosError(error: AxiosError | Error) {
  if (axiosStock.isAxiosError(error)) {
    // Access to config, request, and response
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log(error.response.data)
      // console.log(error.response.status)
      // console.log(error.response.headers)
      return error.response
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // console.log(error.request)

      // Return Error.Message if it exists since it's nicer
      if (error.message) {
        return error.message
      }

      // Return Error.Code if it exists since it's nicer
      if (error.code) {
        return error.code
      }

      return error.request
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.log('Error', error.message)
      return error.message
    }
  } else {
    // Just a stock error
    console.error(`Uncaught axios error: `, error)
    return error
  }
}
